module.exports = __webpack_public_path__ + "static/media/homepage1.f5c811e4.svg";